import React, { useEffect, useState } from 'react';
export function Countdown() {
  // Set a fixed countdown of 2 hours for urgency
  const [timeLeft, setTimeLeft] = useState(2 * 60 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <div className="flex justify-center gap-4 my-6" data-id="element-196">
      <div className="flex flex-col items-center" data-id="element-197">
        <div className="w-16 h-16 bg-white rounded-xl shadow-md flex items-center justify-center text-2xl font-bold text-teal-700 border border-emerald-100" data-id="element-198">
          {hours.toString().padStart(2, '0')}
        </div>
        <span className="text-xs text-gray-600 mt-2 font-medium uppercase tracking-wider" data-id="element-199">
          Horas
        </span>
      </div>
      <div className="text-2xl font-bold text-teal-500 mt-4" data-id="element-200">:</div>
      <div className="flex flex-col items-center" data-id="element-201">
        <div className="w-16 h-16 bg-white rounded-xl shadow-md flex items-center justify-center text-2xl font-bold text-teal-700 border border-emerald-100" data-id="element-202">
          {minutes.toString().padStart(2, '0')}
        </div>
        <span className="text-xs text-gray-600 mt-2 font-medium uppercase tracking-wider" data-id="element-203">
          Minutos
        </span>
      </div>
      <div className="text-2xl font-bold text-teal-500 mt-4" data-id="element-204">:</div>
      <div className="flex flex-col items-center" data-id="element-205">
        <div className="w-16 h-16 bg-white rounded-xl shadow-md flex items-center justify-center text-2xl font-bold text-teal-700 border border-emerald-100" data-id="element-206">
          {seconds.toString().padStart(2, '0')}
        </div>
        <span className="text-xs text-gray-600 mt-2 font-medium uppercase tracking-wider" data-id="element-207">
          Segundos
        </span>
      </div>
    </div>;
}